import { getOrphanGraphElements } from '@/orchestrate/journeys/helpers';
import { http } from '@pendo/http';
import { useEmailsStore } from '@/stores/emails.store';
import { deleteEdge, deleteNode } from './graph/graph.utils';

export function createJourney (journey) {
    return http.post('/api/s/_SID_/journey', journey).then((res) => res.data);
}

export function getAllJourneys () {
    return http.get('/api/s/_SID_/journey').then((res) => res.data);
}

export function updateJourney (journey) {
    return http.put(`/api/s/_SID_/journey/${journey.id}`, journey).then((res) => res.data);
}

export function updateSchedule (id, scheduleData) {
    return http.put(`/api/s/_SID_/journey/${id}/schedule`, scheduleData).then((res) => res.data);
}

export function deleteJourney (id) {
    return http.delete(`/api/s/_SID_/journey/${id}`);
}

export function getJourneyById (id) {
    return http.get(`/api/s/_SID_/journey/${id}`).then((res) => res.data);
}

export function syncEntitiesFromProvidersByJourneyId (journeyId) {
    return http.put(`/api/s/_SID_/journey/${journeyId}/message/sync/external/provider`).then((res) => res.data);
}

export function updateJourneyStatus (journeyId, status) {
    return http.put(`/api/s/_SID_/journey/${journeyId}/status`, { status }).then((res) => res.data);
}

export function updateMessageGraph (journeyId, messageGraph) {
    return http.put(`/api/s/_SID_/journey/${journeyId}/graph`, { messageGraph }).then((res) => res.data);
}

export async function removeOrphanGraphElements (journeyId, messageGraph) {
    const { orphanNodes, orphanEdges, sanitized } = getOrphanGraphElements(messageGraph);

    for (const { id } of orphanEdges) {
        // eslint-disable-next-line no-await-in-loop
        await deleteEdge(journeyId, id);
    }
    for (const { id } of orphanNodes) {
        // eslint-disable-next-line no-await-in-loop
        await deleteNode(journeyId, id);
    }

    return sanitized;
}

export function updateJourneyAudience (journeyId, audience, audienceUiHint, reachInactiveVisitors = false, retainVisitorsAfterEntry = false) {
    return http
        .put(`/api/s/_SID_/journey/${journeyId}/audience`, { audience, audienceUiHint, reachInactiveVisitors, retainVisitorsAfterEntry })
        .then((res) => res.data);
}

export function getAllEmailFieldsOfJourney (messages = []) {
    const emailMessages = messages.filter((message) => message.type === 'Email');
    const fields = emailMessages
        .map((email) => {
            const emailEntity = useEmailsStore().getEmailById(email.id);

            return emailEntity?.emailSettings?.recipientMetadataPropertyName;
        })
        .filter((field) => field != null && field !== '');

    // Remove duplicates
    return [...new Set(fields)];
}
